<div class="installation-data-pymes">
  <div class="installation-data-pymes__header">
    <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.TITLE' | i18nextEager }}</h2>
    <span class="compulsory">* {{ 'COMMONS.REQUIRED' | i18nextEager }}</span>
  </div>
  <form [formGroup]="installationDataMainForm">
    <section>
      <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.MAIN_DATA' | i18nextEager }}</h2>
      <div class="form-block">
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.INSTALLATION_NAME' | i18nextEager }}</mat-label>
          <input matInput formControlName="ins_name" maxlength="40" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.CUPS' | i18nextEager }}</mat-label>
          <input matInput formControlName="ins_cups" />
        </mat-form-field>
        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.CNAE' | i18nextEager }}</mat-label>
          <input matInput formControlName="ins_cnae" numeric [maxlength]="isUserSpain ? 4 : 5" />
          <mat-error
            *ngIf="
              (installationDataMainForm?.get('ins_cnae').errors?.required ||
              installationDataMainForm?.get('ins_cnae').errors?.invalid_cnae) &&
              (installationDataMainForm.get('ins_cnae').touched || installationDataMainForm.get('ins_cnae').dirty)
            "
          >
            {{ (isUserSpain ? 'NEW_CONTRACTS.CNAE_ERROR' : 'NEW_CONTRACTS.PT_CNAE_ERROR') | i18nextEager }}
          </mat-error>
        </mat-form-field>
        <mat-form-field *ngIf="isUserSpain" appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.ACCESS_RATE' | i18nextEager }}</mat-label>
          <input matInput formControlName="ins_access_rate" />
        </mat-form-field>
      </div>
    </section>
  </form>
  <form [formGroup]="installationDataAddressForm">
    <section>
      <h2>{{ 'NEW_CONTRACTS.INSTALLATION_DATA.ADDRESS' | i18nextEager }}</h2>
      <div class="form-block">
        <mat-checkbox (change)="onUseDir($event)">
          {{ 'NEW_CONTRACTS.INSTALLATION_DATA.SAME_DIR' | i18nextEager }}
        </mat-checkbox>

        <app-custom-select
          class="width100"
          [required]="true"
          [label]="'NEW_CONTRACTS.ROAD_TYPE'"
          [controlName]="'ins_road_type'"
          [values]="viaTypesList"
          [searchBar]="true"
          [defaultValue]="defaultValueRoadType"
          [disabled]="addressDisabled"
        ></app-custom-select>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.ROAD_NAME' | i18nextEager }}</mat-label>
          <input matInput formControlName="ins_road_name" maxlength="100" />
        </mat-form-field>

        <div class="tree-col" *ngIf="isUserSpain">
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_NUMBER' | i18nextEager }}</mat-label>
              <input matInput formControlName="ins_number" maxlength="8" alphanumeric />
              <mat-error
                *ngIf="
                  installationDataAddressForm?.get('ins_number').errors?.maxlength &&
                  (installationDataAddressForm?.get('ins_number').touched || installationDataAddressForm?.get('ins_number').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.EIGHT_CHARACTERS_ERROR' | i18nextEager }}
              </mat-error>
              <mat-error
                *ngIf="
                  !installationDataAddressForm?.get('ins_number').errors?.maxlength &&
                  installationDataAddressForm?.get('ins_number').errors?.invalidInitialValue &&
                  (installationDataAddressForm?.get('ins_number').touched || installationDataAddressForm?.get('ins_number').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_GATE' | i18nextEager }}</mat-label>
              <input matInput formControlName="ins_gate" maxlength="10" />
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_STAIR' | i18nextEager }}</mat-label>
              <input matInput formControlName="ins_stair" maxlength="3" alphanumeric />
              <mat-error
                *ngIf="
                  installationDataAddressForm?.get('ins_stair').errors?.maxlength &&
                  (installationDataAddressForm?.get('ins_stair').touched || installationDataAddressForm?.get('ins_stair').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
              </mat-error>
              <mat-error
                *ngIf="
                  !installationDataAddressForm?.get('ins_stair').errors?.maxlength &&
                  installationDataAddressForm?.get('ins_stair').errors?.invalidInitialValue &&
                  (installationDataAddressForm?.get('ins_stair').touched || installationDataAddressForm?.get('ins_stair').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="tree-col">
          <div class="col" *ngIf="isUserSpain">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_FLOOR' | i18nextEager }}</mat-label>
              <input matInput formControlName="ins_floor" maxlength="3" alphanumeric />
              <mat-error
                *ngIf="
                  installationDataAddressForm?.get('ins_floor').errors?.maxlength &&
                  (installationDataAddressForm?.get('ins_floor').touched || installationDataAddressForm?.get('ins_floor').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
              </mat-error>
              <mat-error
                *ngIf="
                  !installationDataAddressForm?.get('ins_floor').errors?.maxlength &&
                  installationDataAddressForm?.get('ins_floor').errors?.invalidInitialValue &&
                  (installationDataAddressForm?.get('ins_floor').touched || installationDataAddressForm?.get('ins_floor').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col" *ngIf="isUserSpain">
            <mat-form-field appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.ADDRESS_DOOR' | i18nextEager }}</mat-label>
              <input matInput formControlName="ins_door" maxlength="3" alphanumeric />
              <mat-error
                *ngIf="
                  installationDataAddressForm?.get('ins_door').errors?.maxlength &&
                  (installationDataAddressForm?.get('ins_door').touched || installationDataAddressForm?.get('ins_door').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.THREE_CHARACTERS_ERROR' | i18nextEager }}
              </mat-error>
              <mat-error
                *ngIf="
                  !installationDataAddressForm?.get('ins_door').errors?.maxlength &&
                  installationDataAddressForm?.get('ins_door').errors?.invalidInitialValue &&
                  (installationDataAddressForm?.get('ins_door').touched || installationDataAddressForm?.get('ins_door').dirty)
                "
              >
                {{ 'NEW_CONTRACTS.INVALID_CHARACTER_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
          </div>
          <div class="col">
            <mat-form-field *ngIf="isUserSpain" appearance="outline">
              <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
              <input matInput formControlName="ins_postal_code" [maxlength]="isUserSpain ? 5 : 8" />
              <mat-error
                *ngIf="
                  installationDataAddressForm?.controls.ins_postal_code.errors?.required &&
                  (installationDataAddressForm.controls.ins_postal_code.touched ||
                    installationDataAddressForm.controls.ins_postal_code.dirty)
                "
              >
                {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
              </mat-error>
            </mat-form-field>
            <div *ngIf="!isUserSpain">
              <div class="installation-data-pymes__pt-postal-code-field">
                <mat-form-field appearance="outline" class="country-code">
                  <mat-label>{{ 'NEW_CONTRACTS.POSTAL_CODE' | i18nextEager }}</mat-label>
                  <input matInput formControlName="ins_postal_code_PT1" maxlength="4" />
                </mat-form-field>
                <p class="installation-data-pymes__postal-code-hyphen">
                  {{ 'NEW_CONTRACTS.POSTAL_CODE_PT_HYPHEN' | i18nextEager }}
                </p>
                <mat-form-field appearance="outline">
                  <input matInput formControlName="ins_postal_code_PT2" maxlength="3" />
                </mat-form-field>
              </div>
              <mat-error
                *ngIf="
                  (installationDataAddressForm?.controls.ins_postal_code_PT1.errors?.required ||
                    installationDataAddressForm?.controls.ins_postal_code_PT2.errors?.required) &&
                  (installationDataAddressForm.controls.ins_postal_code_PT1.touched ||
                    installationDataAddressForm.controls.ins_postal_code_PT1.dirty ||
                    installationDataAddressForm.controls.ins_postal_code_PT2.touched ||
                    installationDataAddressForm.controls.ins_postal_code_PT2.dirty)
                "
                class="installation-data-pymes__pt-postal-code-error"
              >
                {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
              </mat-error>
              <mat-error
                *ngIf="
                  !installationDataAddressForm?.controls.ins_postal_code_PT1.errors?.required &&
                  !installationDataAddressForm?.controls.ins_postal_code_PT2.errors?.required &&
                  installationDataAddressForm?.controls.ins_postal_code.errors?.pattern &&
                  (installationDataAddressForm.controls.ins_postal_code_PT1.touched ||
                    installationDataAddressForm.controls.ins_postal_code_PT1.dirty ||
                    installationDataAddressForm.controls.ins_postal_code_PT2.touched ||
                    installationDataAddressForm.controls.ins_postal_code_PT2.dirty)
                "
                class="installation-data-pymes__pt-postal-code-error"
              >
                {{ 'NEW_CONTRACTS.POSTAL_CODE_ERROR' | i18nextEager }}
              </mat-error>
            </div>
          </div>
        </div>

        <ng-container *ngIf="townList.length < 1 || useSavedValues; else selectTemplate">
          <mat-form-field appearance="outline">
            <mat-label>{{ 'NEW_CONTRACTS.TOWN' | i18nextEager }}</mat-label>
            <input matInput formControlName="ins_town" maxlength="100" />
            <mat-error
              *ngIf="
                installationDataAddressForm?.controls.ins_town.errors?.required &&
                (installationDataAddressForm.controls.ins_town.touched ||
                  installationDataAddressForm.controls.ins_town.dirty)
              "
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
          </mat-form-field>
        </ng-container>

        <ng-template #selectTemplate>
          <app-custom-select
            class="width100"
            [label]="'NEW_CONTRACTS.TOWN'"
            [controlName]="'ins_town'"
            [values]="townList"
            [defaultValue]="defaultValueTown"
            [disabled]="townDisabled"
          >
            <mat-error
              *ngIf="
                installationDataAddressForm?.controls.ins_town.errors?.required &&
                (installationDataAddressForm.controls.ins_town.touched ||
                  installationDataAddressForm.controls.ins_town.dirty)
              "
            >
              {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
            </mat-error>
          </app-custom-select>
        </ng-template>

        <mat-form-field appearance="outline">
          <mat-label>{{ 'NEW_CONTRACTS.PROVINCE' | i18nextEager }}</mat-label>
          <input
            matInput
            formControlName="ins_province"
            maxlength="100"
            placeholder="{{ 'NEW_CONTRACTS.PROVINCE_EXAMPLE' | i18nextEager }}"
          />

          <mat-error
            *ngIf="
              installationDataAddressForm?.controls.ins_province.errors?.required &&
              (installationDataAddressForm.controls.ins_province.touched ||
                installationDataAddressForm.controls.ins_province.dirty)
            "
          >
            {{ 'NEW_CONTRACTS.REQUIRED_ERROR' | i18nextEager }}
          </mat-error>
        </mat-form-field>
      </div>
    </section>
  </form>
</div>
